module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-13.50796c47.jpg";